import React from 'react';
import { Route, Switch } from 'react-router-dom';

import * as routes from 'constants/routes';
import * as filters from 'constants/defaultFilters';
import { GuestRedirect } from 'components/common/GuestRedirect';
import UserRoute, { UserRedirect } from 'components/common/UserRoute';
import withTabRedirect from 'components/hocs/withTabRedirect';

import SecureLayout from 'components/layout/SecureLayout';

import EmailApproval from 'components/views/links/emailApproval/EmailApproval';
import MetroRequestApproval from 'components/views/links/MetroRequestApproval';
import ScenarioLinkView from 'components/views/links/ScenarioLinkView';

import LinkRegistration from 'components/views/education/LinkRegistration';
import RegisrationRedirect from 'components/views/education/RegisrationRedirect';

import LoginView from 'components/views/guest/LoginView';
import ResetView from 'components/views/guest/ResetView';
import RecoveryView, { RecoverySuccessView } from 'components/views/guest/RecoveryView';

import ActionVacancyListView from 'components/views/education/actionVacancyList/ActionVacancyListView';
import ApplicationListView from 'components/views/education/applicationList/ApplicationListView';
import EventsView from 'components/views/education/events/EventsView';
import ApprovalApplicationListView from 'components/views/education/approvalApplicationList/ApprovalApplicationListView';
import CourseListView from 'components/views/education/courseList/CourseListView';

import ScenarioView from 'components/views/education/scenario/ScenarioView';

import CalendarView from 'components/views/calendar/CalendarView';
import NotdoneListView from 'components/views/notdone/NotdoneListView';

import ProfileView from 'components/views/profile/ProfileView';
import AddRequestView from 'components/views/addRequest/AddRequestView';
import RequestListView from 'components/views/requestList/RequestListView';
import ApprovalPersonListView from 'components/views/approvalPersonList/ApprovalPersonListView';
import ApprovalProjectListView from 'components/views/approvalProjectList/ApprovalProjectListView';
import ProjectListView from 'components/views/projectList/ProjectListView';
import WorksheetListView from 'components/views/worksheetList/WorksheetListView';
import ProjectMassListView from 'components/views/projectMass/ProjectMassListView';
import WorksheeetMassListView from 'components/views/worksheetMassList/WorksheetMassListView';

import TrainerEvents from 'components/views/education/trainer/TrainerEvents';
import TrainerTimetable from 'components/views/education/trainer/TrainerTimetable';
import PersonTimetable from 'components/views/education/events/PersonTimetable';
import NewsListView from 'components/views/education/news/NewsListView';
import FileLibraryView from 'components/views/education/fileLibrary/FileLibraryView';

import RoutesError from 'components/views/RoutesError';
import CatchError from 'components/common/CatchError';
import MetroRequest from './views/metro/request/MetroRequest';
import MetroRequests from './views/metro/MetroRequests';
import MetroRequestsApproval from './views/metro/MetroRequestsApproval';

const RequestListViewRedirected = withTabRedirect(RequestListView, routes.request);
const ApprovalPersonListViewRedirected = withTabRedirect(ApprovalPersonListView, routes.approvalPerson);
const ApprovalProjectListViewRedirected = withTabRedirect(ApprovalProjectListView, routes.approvalProject);

const ApplicationListViewRedirected = withTabRedirect(ApplicationListView, routes.applications, filters.defaultApplicationListFilters);
const ApprovalApplicationListViewRedirected = withTabRedirect(ApprovalApplicationListView, routes.approvalApplications, filters.defaultApprovalApplicationListFilters);

const EventsViewRedirected = withTabRedirect(EventsView, routes.events, filters.defaultEventListFilters, 'courses');
const CourseListViewRedirected = withTabRedirect(CourseListView, routes.courses, filters.defaultCourseListFilters, 'assessment');

const MetroRequestsRedirect = withTabRedirect(MetroRequests, routes.requestMetro, filters.defaultMetroRequestFilters, 'all');
const MetroRequestApprovalsRedirect = withTabRedirect(MetroRequestsApproval, routes.requestMetroApproval, filters.defaultMetroRequestApprovalFilters, 'inwork');

export const AppRoutes = () => (
    <Switch>
        <Route path={routes.approvalLink.path} exact component={EmailApproval} />
        <Route path={routes.testLink.path} exact component={ScenarioLinkView} />
        <Route path={routes.metroApprovalLink.path} exact component={MetroRequestApproval} />
        <SecureLayout />
    </Switch>
);

export const GuestRoutes = () => (
    <Switch>
        <Route path={routes.login.path} exact component={LoginView} />
        <Route path={routes.recovery.path} exact component={RecoveryView} />
        <Route path={routes.recoverySuccess.path} exact component={RecoverySuccessView} />
        <Route path={routes.registration.path} exact component={LinkRegistration} />
        <Route path={routes.reset.path} exact component={ResetView} />
        <Route component={GuestRedirect} />
    </Switch>
);

export const UserRoutes = ({ user, permissions, permissions: { web, education, employee } }) => {
    const webPermissions = web || {};
    const employeePermissions = employee || {};

    return (
        <CatchError renderOnError={RoutesError}>
            <Switch>
                <Route path={routes.profile.path} component={ProfileView} />

                <UserRoute path={routes.requestAdd.path} component={AddRequestView} permission={webPermissions.request} />
                <UserRoute path={routes.request.path} component={RequestListViewRedirected} permission={webPermissions.request} />
                <UserRoute path={routes.approvalPerson.path} component={ApprovalPersonListViewRedirected} permission={webPermissions.approvePeople} />
                <UserRoute path={routes.approvalProject.path} component={ApprovalProjectListViewRedirected} permission={webPermissions.approveProjects} />
                <UserRoute path={routes.project.path} component={ProjectListView} permission={webPermissions.project} />
                <UserRoute path={routes.worksheet.path} component={WorksheetListView} permission={webPermissions.project} />
                <UserRoute path={routes.projectMass.path} component={ProjectMassListView} permission={webPermissions.projectMass} exact />
                <UserRoute path={routes.worksheetMassStage.path} component={WorksheeetMassListView} permission={webPermissions.projectMass}  />

                <UserRoute path={routes.requestMetroAdd.path} exact component={MetroRequest} permission={employeePermissions.metroRequest} />
                <UserRoute path={routes.requestMetroEdit.path} component={MetroRequest} permission={employeePermissions.metro} />
                <UserRoute path={routes.requestMetro.path} component={MetroRequestsRedirect} permission={employeePermissions.metroRequest} />
                <UserRoute path={routes.requestMetroApproval.path} component={MetroRequestApprovalsRedirect} permission={employeePermissions.metroApproval} />

                <UserRoute path={routes.calendarCurrent.path} component={CalendarView} permission={web || education} />
                <UserRoute path={routes.calendar.path} component={CalendarView} permission={web || education} />
                <UserRoute path={routes.main.path} component={NotdoneListView} permission={web} exact />

                <UserRoute path={routes.actionVacancies.path} component={ActionVacancyListView} permission={education} />
                <UserRoute path={routes.applications.path} component={ApplicationListViewRedirected} permission={education} />
                <UserRoute path={routes.events.path} component={EventsViewRedirected} permission={education} />
                <UserRoute path={routes.approvalApplications.path} component={ApprovalApplicationListViewRedirected} permission={education && education.approveEducation} />
                <UserRoute path={routes.courses.path} component={CourseListViewRedirected} permission={education} />

                <UserRoute path={routes.trainerEvents.path} component={TrainerEvents} permission={webPermissions.trainerEvents} />
                <UserRoute path={routes.trainerTimetable.path} component={TrainerTimetable} permission={webPermissions.trainerEvents} />

                <UserRoute path={routes.personTimetable.path} component={PersonTimetable} permission={education} />

                <UserRoute path={routes.news.path} component={NewsListView} permission={education} />

                <UserRoute path={routes.scenario.path} component={ScenarioView} permission={education} />

                <Route path={routes.registration.path} component={RegisrationRedirect} />

                <UserRoute path={routes.fileLibrary.path} component={FileLibraryView} permission={education} />

                <Route component={props => <UserRedirect {...props} permissions={permissions} user={user} />} />
            </Switch>
        </CatchError>
    );
};
